import { useEffect, useState } from "react";
import { useBreakpoint } from "../custom-hooks/useBreakpoint";
import { Purpose } from "../domain/enums/Purpose";
import { IPartnersFlat } from "../domain/models/Partners";
import ImagePlaceholderSVG from "./shared/svg/ImagePlaceholder";

interface PartnersCardsBlockProps {
    partners?: IPartnersFlat[];
}

export default function PartnersCardsBlock({ partners = [] }: PartnersCardsBlockProps) {
    const { isMobile, isTablet } = useBreakpoint();
    const [cardsToShow, setCardsToShow] = useState<IPartnersFlat[][]>([]);

    useEffect(() => {
        if (!partners.length) {
            setCardsToShow([]);
            return;
        }

        const rows: IPartnersFlat[][] = [];
        if (isMobile) {
            for (let i = 0; i < partners.length; i += 2) {
                rows.push(partners.slice(i, i + 2));
            }
        } else if (isTablet) {
            for (let i = 0; i < partners.length; i += 3) {
                rows.push(partners.slice(i, i + 3));
            }
        } else {
            rows.push(partners.slice(0, 4));
            if (partners.length > 4) {
                rows.push(partners.slice(4, 8));
            }
        }

        setCardsToShow(rows);
    }, [partners, isMobile, isTablet]);

    if (!cardsToShow.length) return null;
    return (
        <div className="flex flex-col gap-5 pt-[32px] md:pt-[42px] xl:pt-[50px]">
            {cardsToShow.map((row, rowIdx) => (
                <div key={rowIdx} className="flex flex-wrap gap-5 justify-center">
                    {row.map((partner, idx) => (
                        <a
                            key={idx}
                            href={partner.websiteUrl || undefined}
                            target={partner.websiteUrl ? "_blank" : undefined}
                            rel={partner.websiteUrl ? "noopener noreferrer" : undefined}
                            className={`${partner.websiteUrl ? "cursor-pointer" : "cursor-default"}
                                flex flex-col items-center bg-background-100 border border-border-400 
                                        shadow-[0_4px_4px_0_rgba(54,51,82,0.08)] rounded-[6px]  p-2
                                        sm:h-[120px] md:h-[130px] xl:h-[150px]
                                        ${isMobile ? "w-[calc(50%-10px)]" : ""}
                                        ${isTablet ? "w-[calc(33%-13px)]" : ""}
                                        ${!isMobile && !isTablet ? "w-[calc(25%-15px)]" : ""}`}
                        >
                            {partner.pictureExists?.(Purpose.LOGO) ? (
                                <img
                                    src={partner.getPictureUrl?.()}
                                    alt={partner.title}
                                    className="object-contain max-h-[50px] md:max-h-[55px] xl:max-h-[80px] pb-2"
                                />
                            ) : (
                                <ImagePlaceholderSVG fill="#bec6d5" classname="justify-self-center" />
                            )}

                            <p className="font-regular text-lg text-center text-text-300">{partner.title}</p>
                            {partner.description && (
                                <p className="font-regular text-sm text-center text-text-300">{partner.description}</p>
                            )}
                        </a>
                    ))}
                </div>
            ))}
        </div>
    );
}
